import { FC, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import './mojosTab.scss';
import { PlayIcon } from 'tedooo-web-design-system/icons';

import { PopupSlicer } from 'store/popup/PopupActions';
import { EmptyStateOptions, IMojosTab, IStore2, popupIdsOptions } from 'types';
import { List } from 'components/list';
import { translations } from 'translations/en';
import { getElementById } from 'utils';
import { MojosSlicer } from 'store/mojos/MojosSlicer';
import { EmptyState } from 'components/emptyState';
import MojoSkeleton from './skeleton/MojoSkeleton';

const TOTAL_MOJO_SKELETON = 6;

const MojosTab: FC<IMojosTab> = ({ mojos, userId, hasMore, shopId, getUserMojos, showPopup }) => {
  const list = mojos || [...new Array(TOTAL_MOJO_SKELETON)];
  useEffect(() => {
    if (!mojos) {
      getUserMojos({ userId });
    }
  }, [shopId]);

  const onMojoClick = (index: number) => {
    showPopup({ id: popupIdsOptions.mojosPopup, userId, index });
  };

  const itemContent = useCallback(
    (index: number) => {
      const mojo = list[index];

      if (!mojo) {
        return <MojoSkeleton key={index} />;
      }

      return (
        <div
          className="mojo-preview-container"
          onClick={() => onMojoClick(index)}
          style={{ backgroundImage: `url(${mojo.thumbnail})` }}
        >
          <PlayIcon />
        </div>
      );
    },
    [list],
  );

  const onLoadMore = () => {
    getUserMojos({ userId });
  };

  const scrollerElement = getElementById('content');

  return (
    <div className="shop-page-content mojos-tab">
      <div className="section">
        <span className="title">{translations.SHOP.MOJOS}</span>
        <List
          isGrid
          totalCount={list.length}
          data={list}
          hasMore={hasMore}
          emptyState={<EmptyState type={EmptyStateOptions.Mojos} />}
          overscan={100}
          className="shop-mojos-list"
          itemContent={itemContent}
          loadMore={onLoadMore}
          scrollerContainer={scrollerElement}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: IStore2) => {
  const mojos = state.shop.mojos?.list || null;

  const hasMore = !!state.shop.mojos && !!state.shop.mojos.paginationToken;

  const shopId = state.shop.details?.id || '';

  return { mojos, hasMore, shopId };
};

const mapDispatchToProps = {
  showPopup: PopupSlicer.actions.show,
  updateMojoIndex: MojosSlicer.actions.updateCurrentIndex,
};

export default connect(mapStateToProps, mapDispatchToProps)(MojosTab);
